export default {
      id: "reload-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#reload",
      toString: function () {
        return this.url;
      }
    }